import { render, staticRenderFns } from "./wv-reward-message.vue?vue&type=template&id=2d9468d8&scoped=true&"
import script from "./wv-reward-message.vue?vue&type=script&lang=js&"
export * from "./wv-reward-message.vue?vue&type=script&lang=js&"
import style0 from "./wv-reward-message.vue?vue&type=style&index=0&id=2d9468d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9468d8",
  null
  
)

export default component.exports